<template>
  <div v-if="isOpen">
    <TransitionRoot appear :show="isOpen" as="template">
      <Dialog as="div" class="relative z-10">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <div class="fixed inset-0 overflow-y-auto">
          <div class="flex min-h-full items-center justify-center p-4 text-center">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-95"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-95"
            >
              <DialogPanel
                class="
                  w-full
                  max-w-md
                  transform
                  overflow-hidden
                  rounded-md
                  bg-white
                  p-6
                  text-left
                  align-middle
                  shadow-xl
                  transition-all
                "
              >
                <DialogTitle as="h3" class="text-lg font-medium leading-6 text-vice-teal-700">
                  Set up two-factor authentication
                </DialogTitle>
                <div class="mt-7">
                  <p class="text-sm text-gray-500">
                    To enhance your account security,
                    <strong>add a phone number or use an authenticator app</strong>
                    . Your account is blocked until this step is completed.
                    <span class="underline cursor-pointer" @click="openIntercom">Get help</span>
                  </p>
                </div>
                <div class="mt-5 flex items-center justify-center">
                  <jet-nav-link
                    :href="getLinkToProfilepage()"
                    class="bg-vice-teal-600 uppercase font-semibold outline-none"
                  >
                    Secure my accout
                  </jet-nav-link>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>

<script>
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel,
  DialogTitle,
  DialogOverlay,
} from '@headlessui/vue';

import { showNewMessage } from '@intercom/messenger-js-sdk';
import JetNavLink from '@/Jetstream/NavLink.vue';

export default {
  name: 'TwoFactorAuthModal',
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogPanel,
    DialogTitle,
    DialogOverlay,
    JetNavLink,
  },
  mounted() {
    this.checkTwoFactorAuth();
  },
  data() {
    return {
      isOpen: true,
      platformSettings: this.$page.props.platformSettings, // data from app/Http/Middleware/HandleInertiaRequests.php
      userData: this.$page.props.user,
    };
  },
  methods: {
    getLinkToProfilepage() {
      switch (this.userData.role) {
        case 'clinician':
        case 'admin':
          return route('clinician.profile.show');
        default:
          return route('profile.show');
      }
    },

    checkTwoFactorAuth() {
      this.isOpen = this.showModal();
    },

    showModal() {
      // Check if user already setted up 2FA
      if (this.userData.auth_type) {
        return false;
      }

      // Check if 2FA required (in platform settings)
      if (!this.platformSettings.Authentication?.includes('2FA is required')) {
        return false;
      }
      // Do not show modal for profile page
      return !(window.location.href === this.getLinkToProfilepage());
    },

    openIntercom() {
      showNewMessage();
    },
  },
};
</script>
